import { useContext } from 'react';
import { UserContext } from './UserContext';
import { INCOMPLETE_PROFILE_REMINDER_SESSION_KEY } from './utils/onboarding';
import api from './api/axiosInstance';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { useNavigate } from 'react-router-dom';
import Logo from './assets/img/logo.svg';

const Navigation = () => {
    const { user, setUser } = useContext(UserContext);
    const navigate = useNavigate(); // Initialize useNavigate

    const shouldHideHeaderAndNavbar =
        user && (user.role === 'admin' || user.role === 'superadmin') && !user.hasAgreedToTerms;

    const handleLogout = async () => {
        try {
            await api.post('/api/auth/logout'); // ✅ clears HttpOnly cookie token
        } catch (err) {
            console.warn('Logout request failed (continuing):', err?.message || err);
        }

        localStorage.removeItem('token');
        localStorage.removeItem('user');
        sessionStorage.removeItem(INCOMPLETE_PROFILE_REMINDER_SESSION_KEY);
        setUser(null);
        navigate('/', { replace: true });
    };

    return (
        <Navbar expand="lg" className="bg-body-tertiary d-none">
            <Container>
                <Navbar.Brand href="#home">
                    <img src={Logo} alt="aBROADIFY" />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        {/* Show only "Register" and "Login" links if shouldHideHeaderAndNavbar is true */}
                        {shouldHideHeaderAndNavbar ? (
                            <>
                                <Nav.Link className="me-5" href="/register">Register</Nav.Link>
                                <Nav.Link className="me-5" href="/">Login</Nav.Link>
                            </>
                        ) : (
                            <>
                                {/* Show all other navigation links */}
                                {user && (user.role === 'admin' || user.role === 'superadmin') && 
                                    <Nav.Link className="me-5" href="/onboarding-user-list">User List</Nav.Link>
                                }
                                {user && (user.role === 'admin' || user.role === 'superadmin') && 
                                    <Nav.Link className="me-5" href="/user-add">Add User</Nav.Link>
                                }
                                {user && user.role === 'superadmin' && 
                                    <Nav.Link className="me-5" href="/company-add">Add Company</Nav.Link>
                                }
                                {user && (user.role === 'admin' || user.role === 'superadmin' || user.role === 'company') && 
                                    <Nav.Link className="me-5" href="/add-company-user">Add Company User</Nav.Link>
                                }
                                {user && (user.role === 'admin' || user.role === 'superadmin' || user.role === 'company') && 
                                    <Nav.Link className="me-5" href="/onboarding-user-list-company">Company User List</Nav.Link>
                                }
                                {user && (user.role === 'admin' || user.role === 'superadmin' || user.role === 'company') && 
                                    <Nav.Link className="me-5" href="/company-list">Company List</Nav.Link>
                                }
                                {user && (
                                    <>  
                                        <NavDropdown title={user.role} id="basic-nav-dropdown">
                                            <NavDropdown.Item href="#action/3.2">
                                                <Nav.Link onClick={handleLogout} variant="primary">Logout</Nav.Link>
                                            </NavDropdown.Item>
                                        </NavDropdown>
                                    </>
                                )}
                            </>
                        )}
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default Navigation;
